import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { OnboardingStepHeader } from '@/features/onboarding/components/OnboardingStepHeader';
import { OnboardingWizard } from '@/features/onboarding/components/OnboardingWizard';
import { AUTH_ROUTES } from '@/lib/constants';
import { useAuthStore } from '@/stores/authStore';

const onboardingSearch = z.object({
  step: z.enum(['1', '2', '3']).catch('1').default('1'),
});

export const Route = createFileRoute('/client_/onboarding/')({
  validateSearch: onboardingSearch,
  beforeLoad: () => {
    if (!useAuthStore.getState().isAuthenticated) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: AUTH_ROUTES.CLIENT_LOGIN });
    }
  },
  component: OnboardingPage,
});

function OnboardingPage() {
  const { step } = Route.useSearch();
  const stepNumber = Number(step) as 1 | 2 | 3;
  return (
    <AuthLayout
      formSide="right"
      sheetVariant="wizard"
      brandPanel={<ClientAuthBrandPanel hideMobileCopy />}
      mobileHeroExtra={<OnboardingStepHeader step={stepNumber} />}
    >
      <OnboardingWizard />
    </AuthLayout>
  );
}
